import React from 'react';
import { Accordion } from '@uhg-abyss/web/ui/Accordion';

export const FaqMarkdown = ({ children, id, dsUserInfo }) => {
  // Check if the ID exists and includes 'accordion'
  if (id && id.includes('accordion')) {
    // Ensure children is an array and dynamically extract content
    const contentArray = children?.slice(1)?.map((child, index) => {
      // Check if this content has a signin-related ID

      // If it's sign-in content and user is not logged in, return pre text

      // Otherwise return the content
      return child?.props?.children || null;
    });

    const title = children?.[0]?.props?.children?.[0] || 'Accordion Title';

    return (
      <Accordion
        isCollapsible
        css={{
          '.abyss-accordion-content-text div': {
            color: '#000000',
            // padding: '16px',
          },
          '.abyss-accordion-header': {
            // marginBottom: '12px',
            paddingTop: '10px',
            paddingBottom: '10px',
          },
        }}
      >
        <Accordion.Item value={title}>
          <Accordion.Trigger
            style={{
              fontWeight: 'bold',
              fontSize: '16px',
            }}
          >
            <Accordion.Header>{title}</Accordion.Header>
          </Accordion.Trigger>
          <Accordion.Content>
            {contentArray?.map((subCon, index) => {
              return <div key={index}>{subCon}</div>;
            })}
          </Accordion.Content>
        </Accordion.Item>
      </Accordion>
    );
  }
  // Render default div for other IDs
  return <div id={id}>{children}</div>;
};
